import useStyles from './Content.styled'

export const useContent = props => {
	const {
		direction,
		withImage,
		withBgImage,
		isCenterImage,
		isMobile,
		image,

		title,
		subtitle,
		text,
		buttonText,
		buttonAction,
		buttonLink,
		onImageClick,
		onTitleClick,
		onSubtitleClick,
		onTextClick,
		onButtonClick,
		extraShortcuts,
		textEditable,
		titleEditable,
		subtitleEditable,
		onTextChange,
		onTitleChange,
		onSubtitleChange,
		titleConfig,
		subtitleConfig,
		textConfig,
		buttonTextConfig,
		buttonTextEditable,
		onButtonTextChange,
		titleKey,
		subtitleKey,
		textKey,
		buttonTextKey,
	} = props

	const classes = useStyles(props)

	return [
		{
			withBgImage,
			isCenterImage,
			isMobile,
			direction,
			classes,
			withImage,
			image,

			title,
			subtitle,
			text,
			buttonText,
			buttonAction,
			buttonLink,
			extraShortcuts,
			textEditable,
			titleEditable,
			subtitleEditable,
			titleConfig,
			subtitleConfig,
			textConfig,
			buttonTextConfig,
			buttonTextEditable,
			titleKey,
			subtitleKey,
			textKey,
			buttonTextKey,
		},
		{
			handleImageClick: onImageClick,
			handleTitleClick: onTitleClick,
			handleSubtitleClick: onSubtitleClick,
			handleTextClick: onTextClick,
			handleButtonClick: onButtonClick,
			handleTextChange: onTextChange,
			handleTitleChange: onTitleChange,
			handleSubtitleChange: onSubtitleChange,
			handleButtonTextChange: onButtonTextChange,
		},
	]
}
